import React from "react";
import { Link } from 'react-router-dom';
import FAQ from './faq'
const aboutUs = () => {
    return (


        <section className="section-padding about-us-faq">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-5">
                        <div className="about-us-section">
                            <div className="section-title-s3">
                                <span>درباره ما</span>
                                <h2>ساخت و بروزرسانی دستگاه های بومی صنعت نساجی با فناوری دانش محور و پرسنل متخصص و با تجربه</h2>
                            </div>
                            <div className="details">
                                <p>شرکت دانش بنیان آپافن فعالیت خود را با هدف توسعه خودکفایی و تامین نیازهای فنی صنایع نساجی، از سال 1390 آغاز نموده است.</p>
                                <p>این شرکت با بهره‌گیری از پرسنل متخصص، تجربه فنی و دانش اقدام به ساخت دستگاه‌های بومی نموده است تا با نوآوری و تولید بومی وابستگی خارجی را به حداقل برساند.</p>
                                <div className="btns">
                                    <Link to="about" className="theme-btn-s3">بیشتر بدانید</Link>
                                    {/* <Link to="#" className="theme-btn-s4">تاریخچه شرکت</Link> */}
                                </div>
                            </div>
                            <div className="social">
                                <p>با ما ارتباط برقرار کنید:</p>
                                <ul className="social-links">
                                    <li><a href="https://www.facebook.com/Apafanco/" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook-square"></i></a></li>
                                    <li><a href="https://www.aparat.com/Apafan" target="_blank" rel="noopener noreferrer" ><i className="icon-aparat-ichallenge-logoap"></i></a></li>
                                    <li><a href="https://www.instagram.com/apafan.co/" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram"></i></a></li>
                                    <li><Link to="#"><i className="fa fa-linkedin-square"></i></Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <FAQ />
                </div>

            </div>

            <div className="backhoe-loader">
                <img src="assets/images/backhoe-loader.png" alt='' role='presentation' />
            </div>
        </section>


    );
};

export default aboutUs;